import {
  CREATE_NEW_AD,
  DELETE_AD_ERROR,
  DELETE_AD_SUCCESS,
  DUPLICATE_AD,
  DUPLICATE_AD_ERROR,
  DUPLICATE_AD_SUCCESS,
  GET_ADS,
  GET_ADS_ERROR,
  GET_ADS_STATS,
  GET_ADS_STATS_ERROR,
  GET_ADS_STATS_SUCCESS,
  GET_ADS_SUCCESS,
  GET_QF_CREATIVES_STATS,
  GET_QF_CREATIVES_STATS_ERROR,
  GET_QF_CREATIVES_STATS_SUCCESS,
  MODIFY_AD,
  MODIFY_AD_ERROR,
  MODIFY_AD_SUCCESS,
  NEW_AD_ERROR,
  NEW_AD_SUCCESS
} from "./actionTypes"

const initialState = {
  ads: [],
  ads_stats: [],
  qf_creatives_stats: [],
  error: null,
  loading: false,
  creatives_create_update_loading: false,
  loading_ads_stats: false,
  loading_qf_creatives_stats: false,
  last_fetch_time_frame_key: null
}

const Ads = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADS:
      return {
        ...state,
        loading: true
      }
    case GET_ADS_SUCCESS:
      return {
        ...state,
        ads: action.payload,
        loading: false,
      }

    case GET_ADS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false

      }

    case MODIFY_AD:
      return {
        ...state,
        creatives_create_update_loading: true
      }
    case MODIFY_AD_SUCCESS:
      return {
        ...state,
        ads: state.ads.map(ad => ad.id == action.payload.id
          ? { ad, ...action.payload }
          : ad,
        ),
        creatives_create_update_loading: false
      }

    case MODIFY_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        creatives_create_update_loading: false,
      }

    case CREATE_NEW_AD:
      return {
        ...state,
        creatives_create_update_loading: true
      }


    case NEW_AD_SUCCESS:
      return {
        ...state,
        ads: [...state.ads, action.payload],
        creatives_create_update_loading: false
      }

    case NEW_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        creatives_create_update_loading: false
      }

    case DUPLICATE_AD:
      return {
        ...state,
        loading: true
      }

    case DUPLICATE_AD_SUCCESS:
      return {
        ...state,
        ads: [...state.ads, action.payload],
        loading: false
      }

    case DUPLICATE_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_AD_SUCCESS:
      return {
        ...state,
        ads: state.ads.filter(ad => ad.id != action.payload.id),
        loading: false
      }

    case DELETE_AD_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_ADS_STATS:
      return {
        ...state,
        loading_ads_stats: true,
      }

    case GET_ADS_STATS_SUCCESS:
      return {
        ...state,
        ads_stats: action.payload,
        last_fetch_time_frame_key: action.time_frame_key,
        loading_ads_stats: false,
      }

    case GET_ADS_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_ads_stats: false,
      }

    case GET_QF_CREATIVES_STATS:
      return {
        ...state,
        loading_qf_creatives_stats: true,
      }

    case GET_QF_CREATIVES_STATS_SUCCESS:
      return {
        ...state,
        qf_creatives_stats: action.payload,
        last_fetch_time_frame_key: action.time_frame_key,
        loading_qf_creatives_stats: false,
      }

    case GET_QF_CREATIVES_STATS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_qf_creatives_stats: false,
      }

    default:
      return state
  }
}

export default Ads;
